import React, { useMemo } from 'react';
import trans from 'translate';
import PropTypes from 'prop-types';

import './PoolsLegend.scss';
import Tooltip from '../Tooltip/Tooltip';

const PoolsLegend = ({ type, poolType }) => {
  const legendData = useMemo(
    () => [
      {
        className: 'gray',
        text: trans('champion.pools_legend_deposit_funds'),
        type: 'champion',
        tooltipTitle: trans('champion.legend_tooltip_deposit_title'),
        tooltipText: trans('champion.legend_tooltip_deposit'),
        poolType: 'hpool',
      },
      {
        className: 'dark-gray',
        text: trans('champion.pools_legend_creating'),
        type: 'champion',
        tooltipTitle: trans('champion.legend_tooltip_creating_title'),
        tooltipText: trans('champion.legend_tooltip_creating'),
        poolType: 'hpool',
      },
      {
        className: 'yellow',
        text: trans('champion.pools_legend_ticket_sale'),
        type: 'user',
        tooltipTitle: trans('champion.legend_tooltip_ticket_sale_title'),
        tooltipText: trans('champion.legend_tooltip_ticket_sale'),
        poolType: 'hpool',
      },
      {
        className: 'dark-green',
        text: trans('hpool.private_subscribtion'),
        type: 'user',
        tooltipTitle: trans('champion.legend_tooltip_subscription_title'),
        tooltipText: trans('champion.legend_tooltip_subscription'),
        poolType: 'hpool',
      },
      {
        className: 'green',
        text: trans('hpool.public_subscribtion'),
        type: 'user',
        tooltipTitle: trans('champion.legend_tooltip_subscription_title'),
        tooltipText: trans('champion.legend_tooltip_subscription'),
        poolType: 'hpool',
      },
      {
        className: 'blue',
        text: trans('champion.pools_legend_deploying'),
        type: 'champion',
        tooltipTitle: trans('champion.legend_tooltip_deploying_title'),
        tooltipText: trans('champion.legend_tooltip_deploying'),
        poolType: 'hpool',
      },
      {
        className: 'dark-blue',
        text: trans('champion.pools_legend_live'),
        type: 'user',
        tooltipTitle: trans('champion.legend_tooltip_live_title'),
        tooltipText: trans('champion.legend_tooltip_live'),
        poolType: 'hpool',
      },
      {
        className: 'orange',
        text: trans('champion.pools_legend_updating'),
        type: 'champion',
        tooltipTitle: trans('champion.legend_tooltip_updating_title'),
        tooltipText: trans('champion.legend_tooltip_updating'),
        poolType: 'hpool',
      },
      {
        className: 'red',
        text: trans('champion.pools_legend_ending'),
        type: 'champion',
        tooltipTitle: trans('champion.legend_tooltip_ending_title'),
        tooltipText: trans('champion.legend_tooltip_ending'),
        poolType: 'hpool',
      },
      {
        className: 'dark',
        text: trans('champion.pools_legend_ended'),
        type: 'user',
        tooltipTitle: trans('champion.legend_tooltip_ended_title'),
        tooltipText: trans('champion.legend_tooltip_ended'),
        poolType: 'hpool',
      },
      {
        className: 'dark-purple',
        text: trans('hpool.whitelisting'),
        type: 'user',
        tooltipTitle: trans('vpool.legend_tooltip_whitelisting_title'),
        tooltipText: trans('vpool.legend_tooltip_whitelisting'),
        poolType: 'vpool',
      },
      {
        className: 'purple2',
        text: trans('vpool.participation'),
        type: 'user',
        tooltipTitle: trans('vpool.participation'),
        tooltipText: trans('vpool.legend_tooltip_participation_text'),
        poolType: 'vpool',
      },
      {
        className: 'light-purple',
        text: trans('vpool.live_and_traded'),
        type: 'user',
        tooltipTitle: trans('vpool.live_tooltip_title'),
        tooltipText: trans('vpool.live_tooltip_text'),
        poolType: 'vpool',
      },
    ],
    [],
  );

  const filteredLegend = useMemo(
    () => legendData.filter((data) => (!poolType ? data : data.poolType === poolType)),
    [legendData, poolType],
  );

  return (
    <div className="c-pools-legend">
      <ul>
        <li className="title">{trans('champion.pools_legend_title')}</li>
        {filteredLegend.map(
          (data) =>
            (type === 'champion' || (type === 'user' && type === data.type)) && (
              <li className="phase" key={`circle-${data.className}`}>
                <span className={`circle ${data.className}`}>&nbsp;</span>
                <Tooltip className="phase-legend-tooltip" title={data.tooltipTitle} text={data.tooltipText}>
                  <span>{data.text}</span>
                </Tooltip>
              </li>
            ),
        )}
      </ul>
    </div>
  );
};

PoolsLegend.defaultProps = {
  type: 'user',
  poolType: '',
};

PoolsLegend.propTypes = {
  type: PropTypes.oneOf(['user', 'champion']),
  poolType: PropTypes.string,
};

export default PoolsLegend;
